<template>
  <div class="page-container">
    <el-card>
      <app-filter
        ref="app_filter"
        :filter-list="table_filter"
        default-label-width="100px"
        @search="onSearch"
      >
        <template #actions>
          <el-button v-if="isJrttV3" type="primary" @click="onAddMaterial">添加素材</el-button>
        </template>
      </app-filter>
    </el-card>
    <el-card class="mt-20">
      <div class="flex justify-between mb-20">
        <div>
          <el-select v-model="batch_config.value" size="mini" class="mr-20" placeholder="请选择批量操作">
            <el-option v-for="item in batch_config.options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-button size="mini" type="primary" @click="onBatch">批量操作</el-button>
        </div>
        <el-button type="success" size="mini" @click="onPull">同步</el-button>
      </div>
      <app-table
        ref="table"
        :table-key="table_key"
        :table-props="{ 'max-height': '550px' }"
        :tablep="table_params"
        :is-request="false"
        :page-size="10"
        :get-data="getCreativeList"
        :is-row-click="false"
        :check="true"
        @select-tr="onSelectionChange"
      />
    </el-card>
    <el-drawer
      :title="drawer_config.title"
      :visible.sync="drawer_config.is_show"
      size="1000px"
    >
      <multiple-app-form
        v-if="drawer_config.is_show"
        ref="multiple_app_form"
        v-loading="drawer_config.is_loading"
        :form-fields="drawer_config.form_fields"
        @confirm="drawer_config.confirm"
        @cancel="drawer_config.cancel"
      >
        <template #custom="{form_item, form_key}">
          <component
            :is="getComponentName(form_key)"
            v-if="getComponentName(form_key)"
            :form-item="form_item"
            v-bind="getComponentProps(form_item, form_key)"
          />
        </template>
      </multiple-app-form>
    </el-drawer>
  </div>
</template>

<script>
import { getMediasListApi } from '@/api/medias';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { getCampaignSelectorApi } from '@/api/campaign';
import {
  getCreativeListApi,
  pullCreativeStatusApi,
  getCreativeDetailApi,
  editCreativeApi,
  updateCreativeStatusApi,
  deteleCreativeApi,
} from '@/api/creative';
import { clone } from '@/utils';
import calculator from '@/utils/calculator';

import getFormFields, { getAddMaterialFormFields } from './model/form-fields.js';
import { hasCreativeContent, transformCreativeContent } from './model/creative-content.js';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
    'multiple-app-form': () => import('../components/multiple-app-form'),
    'material-form': () => import('@/components/business/material/material-form'),
    'title-form': () => import('./components/title-form'),
    'site-form': () => import('./components/site-form'),
  },
  data() {
    return {
      table_key: require('./model/table-key.js')(this),
      table_filter: require('./model/table-filter.js')(this),
      table_params: {
        page: 1,
        limit: 10,
      },
      /** 表格多选数据 */
      table_multiple_selection: [],
      /** 批量操作 */
      batch_config: {
        value: 'del',
        options: [
          {
            label: '批量删除',
            value: 'del',
          },
        ],
      },
      /** 弹窗配置 */
      drawer_config: {
        is_show: false,
        is_loading: false,
        title: '新增',
        id: null,
        context: {},
        form_fields: {},
        component_config: {
          material: {
            component_name: 'material-form',
            getProps: (form_item) => {
              return {
                channelInterface: this.drawer_config.context.channel_interface,
                materialData: form_item.value,
              };
            },
          },
          titles: {
            component_name: 'title-form',
            getProps: () => {
              return {
                channelInterface: this.drawer_config.context.channel_interface,
              };
            },
          },
          sites: {
            component_name: 'site-form',
            getProps: (form_item) => {
              return {
                channelInterface: this.drawer_config.context.channel_interface,
                advertiserId: this.drawer_config.context.advertiser_id,
                extraParams: form_item.extra_params || {},
              };
            },
          },
        },
        confirm: () => {},
      },
      /** 枚举表 */
      enum_map: {
        status: {
          'ENABLE': '开启',
          'DISABLE': '关闭',
        },
      },
    };
  },
  computed: {
    isJrttV3() {
      return this.table_filter.channel_interface.value === CHANNEL_INTERFACE_TYPE.JRTT_V3;
    },
  },
  async mounted() {
    // 广告管理携带跳转参数时，使用跳转参数请求列表
    if (Object.keys(this.$route.params).length > 0) {
      const { advertiser_id, channel_interface, campaign_id } = this.$route.params;
      this.table_filter.advertiser_id.value = advertiser_id;
      this.table_filter.channel_interface.value = channel_interface;
      this.table_filter.filtering.children.campaign_id.value = campaign_id;
      this.syncCampaignRequiredRule();
      this.$refs.app_filter.search();
      this.table_filter.filtering.children.campaign_id.options = await this.getCampaignSelector({
        channel_interface: channel_interface,
        advertiser_id: advertiser_id,
      });
    }
    this.table_filter.advertiser_id.options = await this.getAdvertiserList(this.$route.params.channel_interface || CHANNEL_INTERFACE_TYPE.JRTT);
  },
  methods: {
    /** 同步智擎版广告必填规则 */
    syncCampaignRequiredRule() {
      const campaign_id = this.table_filter.filtering.children.campaign_id;
      campaign_id.rules = this.isJrttV3
        ? { required: true, message: '请选择广告', trigger: 'change' }
        : undefined;
    },
    /**
     * 搜索
     * @param {Object} params 搜索条件
     */
    onSearch(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },
    /** 为智擎版广告添加素材或标题 */
    onAddMaterial() {
      const {
        channel_interface,
        advertiser_id,
        filtering: { children: { campaign_id }},
      } = this.table_filter;
      if (!campaign_id.value) {
        this.$message.warning('请选择广告');
        return;
      }

      const context = {
        id: campaign_id.value,
        channel_interface: channel_interface.value,
        advertiser_id: advertiser_id.value,
      };
      Object.assign(this.drawer_config, {
        is_show: true,
        is_loading: false,
        title: '添加素材',
        context,
        form_fields: getAddMaterialFormFields(),
        confirm: ({ creative_message }) => {
          if (this.drawer_config.is_loading) {
            return;
          }
          if (!hasCreativeContent(creative_message)) {
            this.$message.warning('请至少选择素材或标题');
            return;
          }
          const payload = {
            channel_interface: context.channel_interface,
            advertiser_id: context.advertiser_id,
            ...transformCreativeContent(creative_message),
          };
          this.drawer_config.is_loading = true;
          editCreativeApi(context.id, payload).then(({ message }) => {
            this.$message.success(message || '添加成功');
            this.drawer_config.is_show = false;
          }).finally(() => {
            this.drawer_config.is_loading = false;
          });
        },
        cancel: () => {
          this.drawer_config.is_show = false;
        },
      });
    },
    /**
     * 同步
     */
    onPull() {
      const { channel_interface, advertiser_id } = this.table_filter;
      if (!advertiser_id.value) {
        this.$message.warning('请选择广告主账户');
        return;
      }
      pullCreativeStatusApi({
        channel_interface: channel_interface.value,
        advertiser_id: advertiser_id.value,
      }).then(({ message }) => {
        this.$message.success(message || '同步成功');
        this.$refs.table.seekTable();
      });
    },
    /**
     * 编辑
     * @param {Object} row 当前行数据
     */
    async onEdit(row) {
      const { channel_interface, advertiser_id } = this.table_params;
      const data = clone(row);
      const { id } = data;
      Object.assign(this.drawer_config, {
        is_show: true,
        is_loading: true,
        title: '编辑',
        context: { id, channel_interface, advertiser_id },
        form_fields: getFormFields(),
        confirm: (params) => {
          const {
            creative_message: {
              material,
              titles,
              sites,
            },
            creative_price: {
              budget,
              cpa_bid,
              deep_cpabid,
              roi_goal,
              first_roi_goal,
            },
          } = params;
          const jrtt_params = {
            ...(budget && { budget: calculator.times(budget, 100) }),
            ...(cpa_bid && { cpa_bid: calculator.times(cpa_bid, 100) }),
            ...(deep_cpabid && { deep_cpabid: calculator.times(deep_cpabid, 100) }),
            ...(roi_goal && { roi_goal }),
            ...(first_roi_goal && { first_roi_goal }),
          };
          const payload = {
            channel_interface,
            advertiser_id,
            ...transformCreativeContent({ material, titles }),
            ...(sites?.length && { sites }),
            ...(Object.keys(jrtt_params).length && { jrtt_params }),
          };

          editCreativeApi(id, payload).then(({ message }) => {
            this.$message.success(message || '编辑成功');
            this.drawer_config.is_show = false;
            this.$refs.table.seekTable();
          });
        },
        cancel: () => {
          this.drawer_config.is_show = false;
        },
      });

      const creative_detail = await getCreativeDetailApi(id, { channel_interface, advertiser_id });

      const {
        creative_name,
        videos = [],
        images = [],
        titles = [],
        sites = [],
        jrtt_params: {
          budget,
          cpa_bid,
          deep_cpabid,
          roi_goal,
          first_roi_goal,
        },
      } = creative_detail;

      const videos_list = videos.map(({ cover, url, ...rest }) => ({ url: [{ thumb_url: cover, url }], ...rest }));
      const images_list = images.map(({ urls, ...rest }) => ({ url: urls.map(item => ({ url: item, thumb_url: item })), ...rest }));
      const titles_list = titles.map(name => ({ name }));
      const {
        base_form: {
          config: {
            creative_name: creative_name_field,
          },
        },
        creative_message: {
          config: {
            material: material_field,
            titles: titles_field,
            sites: sites_field,
          },
        },
        creative_price: {
          config: {
            budget_selection: budget_selection_field,
            budget: budget_field,
            cpa_bid: cpa_bid_field,
            deep_cpabid: deep_cpabid_field,
            roi_goal: roi_goal_field,
            first_roi_goal: first_roi_goal_field,
          },
        },
      } = this.drawer_config.form_fields;
      const mapTuple = [
        // 创意名称
        () => {
          Object.assign(creative_name_field, { value: creative_name });
        },
        // 素材
        () => {
          const is_has_material = images_list.length || videos_list.length;
          if (!is_has_material) {
            material_field.hidden = true;
            return;
          }
          images_list.length && (material_field.value.images = images_list);
          videos_list.length && (material_field.value.videos = videos_list);
        },
        // 标题
        () => {
          const is_has_titles = titles.length;
          if (!is_has_titles) {
            titles_field.hidden = true;
            return;
          }
          titles_field.value = titles_list;
        },
        // 落地页
        () => {
          const is_has_sites = sites.length;
          if (!is_has_sites) {
            sites_field.hidden = true;
            return;
          }
          sites_field.value = sites;
        },
        // 创意预算
        () => {
          if (budget) {
            budget_selection_field.hidden = false;
            budget_field.hidden = false;
            budget_field.value = calculator.div(budget, 100);
          }
        },
        // 优化目标出价
        () => {
          if (cpa_bid) {
            cpa_bid_field.hidden = false;
            cpa_bid_field.value = calculator.div(cpa_bid, 100);
          }
        },
        // 深度优化出价
        () => {
          if (deep_cpabid) {
            deep_cpabid_field.hidden = false;
            deep_cpabid_field.value = calculator.div(deep_cpabid, 100);
          }
        },
        // 深度ROI系数出价
        () => {
          if (roi_goal) {
            roi_goal_field.hidden = false;
            roi_goal_field.value = roi_goal;
          }
        },
        // 首日ROI系数出价
        () => {
          if (first_roi_goal) {
            first_roi_goal_field.hidden = false;
            first_roi_goal_field.value = first_roi_goal;
          }
        },
      ];

      mapTuple.forEach((handler) => handler());
      this.drawer_config.is_loading = false;
    },
    /**
     * 切换状态
     * @param {Object} row 当前行数据
     */
    onSwitch(row) {
      const { id, name, status } = row;
      const is_enable = status === 'ENABLE';
      const h = this.$createElement;
      const message_ele = h('div', { class: 'flex-col align-center' }, [
        h('div', { class: 'mb-10 color-red' }, name),
        h('div', { class: 'mb-10' }, `是否将当前已选中的创意设置为${is_enable ? '关闭' : '开启'}状态`),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        const { channel_interface, advertiser_id } = this.table_filter;
        const params = {
          channel_interface: channel_interface.value,
          advertiser_id: advertiser_id.value,
          status: is_enable ? 'DISABLE' : 'ENABLE',
        };
        updateCreativeStatusApi(id, params).then(({ message }) => {
          this.$message.success(message || '操作成功');
          this.$refs.table.seekTable();
        });
      });
    },
    /**
     * 删除
     * @param {string[]} ids 当前行数据
     */
    onDel(ids) {
      const h = this.$createElement;
      const message_ele = h('div', { class: 'flex-col align-center' }, [
        ...((ids || []).map(id => h('div', { class: 'mb-10 color-red' }, id))),
        h('div', { class: 'mb-10' }, '是否删除当前已选中的创意'),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        const { channel_interface, advertiser_id } = this.table_filter;
        const params = {
          channel_interface: channel_interface.value,
          advertiser_id: advertiser_id.value,
          ids,
        };
        deteleCreativeApi(params).then(({ message }) => {
          this.$message.success(message || '操作成功');
          this.$refs.table.seekTable();
          this.table_multiple_selection.splice(0);
        });
      });
    },
    /** 批量操作 */
    onBatch() {
      switch (this.batch_config.value) {
        case 'del':
          this.onBatchDel();
          break;
        default:
          break;
      }
    },
    /**
     * 批量删除
     */
    onBatchDel() {
      if (!this.table_multiple_selection.length) {
        this.$message.warning('请选择创意！');
        return;
      }
      const ids = this.table_multiple_selection.map(({ id }) => id);
      this.onDel(ids);
    },
    /**
     * 表格多选事件
     * @param {Object[]} rows 当前选中数据
     */
    onSelectionChange(rows) {
      this.table_multiple_selection = rows;
    },
    /**
     * 获取创意列表
     * @param {Object} params 请求参数
     * @returns {Promise<Object>}
     */
    getCreativeList(params) {
      return new Promise((resolve, reject) => {
        getCreativeListApi(params).then(resolve).catch(reject);
      });
    },
    /**
     * 获取广告主账号列表
     * @param {string} type 渠道接口
     * @returns {Promise<Object[]>}
     */
    getAdvertiserList(type) {
      return new Promise((resolve, reject) => {
        getMediasListApi({
          type,
          is_list: true,
        }).then(res => {
          const result = res.list.map(({ advertiser_id, advertiser_name, note }) => {
            return {
              label: `${advertiser_id}（${advertiser_name}）${note ? ' - ' + note : ''}`,
              value: advertiser_id,
            };
          });
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取广告主账号列表
     * @param {string} type 渠道接口
     * @returns {Promise<Object[]>}
     */
    getCampaignSelector(params) {
      return new Promise((resolve, reject) => {
        getCampaignSelectorApi(params).then(({ message = [] }) => {
          const result = message.map(({ id: value, name: label }) => ({ label, value }));
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取组件名称
     * @param form_key 表单键
     * @returns {String|null}
     */
    getComponentName(form_key) {
      return this.drawer_config.component_config[form_key]?.component_name || null;
    },
    /**
     * 获取组件配置
     * @param form_key 表单键
     * @returns {Object}
     */
    getComponentProps(form_item, form_key) {
      return this.drawer_config.component_config[form_key]?.getProps?.(form_item) || {};
    },
  },
};
</script>
